(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battle-pdp-2026-media"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  function mount(root) {
    if (controllers.has(root)) return;
    const desktop = matchMedia('(min-width: 768px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const panels = [...root.querySelectorAll('[data-device]')];
    const videos = panels.map(panel => panel.querySelector('video')).filter(Boolean);
    const manualPaused = new WeakSet();
    const automaticPauses = new WeakSet();
    const handlers = [];
    panels.forEach(panel => {
      const video = panel.querySelector('video');
      const tools = panel.querySelector('[data-video-tools]');
      if (!video || !tools || root.dataset.autoplay !== 'true') return;
      const toggle = tools.querySelector('[data-video-toggle]');
      const sound = tools.querySelector('[data-video-sound]');
      function updateControls() {
        tools.dataset.playing = String(!video.paused && !video.ended);
        tools.dataset.muted = String(video.muted);
        toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        sound.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        sound.setAttribute('aria-pressed', String(!video.muted));
      }
      function togglePlayback() {
        load(video);
        if (video.paused) {
          manualPaused.delete(video);
          video.play().catch(() => {});
        } else {
          manualPaused.add(video);
          video.pause();
        }
      }
      function toggleSound() { video.muted = !video.muted; updateControls(); }
      video.controls = false;
      tools.hidden = false;
      toggle.addEventListener('click', togglePlayback);
      sound.addEventListener('click', toggleSound);
      ['play', 'pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, updateControls));
      updateControls();
      handlers.push(() => {
        toggle.removeEventListener('click', togglePlayback);
        sound.removeEventListener('click', toggleSound);
        ['play', 'pause', 'ended', 'volumechange'].forEach(name => video.removeEventListener(name, updateControls));
      });
    });
    let active = null;
    let visible = false;
    let destroyed = false;
    function load(video) {
      if (!video || video.dataset.loaded) return;
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      video.dataset.loaded = 'true';
      video.load();
    }
    function pause(video) {
      if (!video || video.paused) return;
      automaticPauses.add(video);
      video.pause();
    }
    function sync() {
      const panel = panels.find(item => item.dataset.device === (desktop.matches ? 'desktop' : 'mobile'));
      const next = panel && panel.querySelector('video');
      if (next !== active) { pause(active); active = next; visible = false; }
      videos.forEach(video => { if (video !== active) pause(video); });
      if (!active) return;
      if (!visible || document.hidden) { pause(active); return; }
      load(active);
      if (root.dataset.autoplay !== 'true' || reduced.matches || manualPaused.has(active)) return;
      const current = active;
      current.play().then(() => {
        if (destroyed || current !== active || !visible || document.hidden || reduced.matches) pause(current);
      }).catch(() => {});
    }
    videos.forEach(video => {
      const onPause = () => {
        if (automaticPauses.has(video)) automaticPauses.delete(video);
        else if (!video.ended) manualPaused.add(video);
      };
      const onPlay = () => { manualPaused.delete(video); };
      const onPointer = () => load(video);
      const onKey = () => load(video);
      video.addEventListener('pause', onPause);
      video.addEventListener('play', onPlay);
      video.addEventListener('pointerdown', onPointer);
      video.addEventListener('keydown', onKey);
      handlers.push(() => {
        video.removeEventListener('pause', onPause);
        video.removeEventListener('play', onPlay);
        video.removeEventListener('pointerdown', onPointer);
        video.removeEventListener('keydown', onKey);
      });
    });
    const near = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target.dataset.device === (desktop.matches ? 'desktop' : 'mobile')) {
          load(entry.target.querySelector('video'));
        }
      });
    }, { rootMargin: '300px 0px' });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target.dataset.device === (desktop.matches ? 'desktop' : 'mobile')) {
          visible = entry.isIntersecting && entry.intersectionRatio >= .5;
          sync();
        }
      });
    }, { threshold: [0, .5] });
    sync();
    panels.forEach(panel => { near.observe(panel); observer.observe(panel); });
    function breakpoint() {
      sync();
      panels.forEach(panel => { observer.unobserve(panel); observer.observe(panel); });
    }
    function motion() {
      if (reduced.matches) pause(active);
      else sync();
    }
    desktop.addEventListener('change', breakpoint);
    reduced.addEventListener('change', motion);
    document.addEventListener('visibilitychange', sync);
    controllers.set(root, () => {
      destroyed = true;
      near.disconnect();
      observer.disconnect();
      desktop.removeEventListener('change', breakpoint);
      reduced.removeEventListener('change', motion);
      document.removeEventListener('visibilitychange', sync);
      handlers.forEach(cleanup => cleanup());
      videos.forEach(pause);
    });
  }
  function scan(scope) { scope.querySelectorAll('[data-battle-media]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((cleanup, root) => {
      if (event.target.contains(root)) { cleanup(); controllers.delete(root); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["battle-pdp-2026-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  const normalize = value => (value || '').trim().toLowerCase();
  function mount(root) {
    if (controllers.has(root)) return;
    const wrap = root.querySelector('.battle-story__media');
    if (!wrap) return;
    const items = Array.from(wrap.querySelectorAll('.battle-story__item'));
    const main = document.querySelector('.battle-pdp-2026');
    if (!items.length) return;
    let frame = 0;
    let active = null;
    function update() {
      frame = 0;
      const selected = main && Array.from(main.querySelectorAll('._main_color_selected')).find(el => el.getClientRects().length && normalize(el.textContent));
      const slide = main && main.querySelector('.main_product_slider .swiper-slide-active');
      const color = normalize(selected ? selected.textContent : slide && slide.dataset.alt);
      const matches = color ? items.filter(item => normalize(item.dataset.storyColor).includes(color)) : [];
      const next = matches.find(item => item.dataset.storyType === 'video') || matches[0] || items.find(item => item.dataset.storyType === 'video') || items[0];
      if (next === active) return;
      active = next;
      items.forEach(item => {
        item.classList.toggle('is-active', item === next);
        const video = item.querySelector('video');
        if (video && item !== next) video.pause();
      });
      wrap.setAttribute('data-story-ready', '');
      const video = next.querySelector('video');
      if (video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.muted = true;
        video.play().catch(() => {});
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    const observer = new MutationObserver(schedule);
    if (main) {
      observer.observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      main.addEventListener('change', schedule);
      main.addEventListener('click', schedule);
    }
    controllers.set(root, () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      if (main) {
        main.removeEventListener('change', schedule);
        main.removeEventListener('click', schedule);
      }
      items.forEach(item => { const video = item.querySelector('video'); if (video) video.pause(); });
    });
    update();
  }
  function scan(scope) { scope.querySelectorAll('[data-battle-story]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('.battle-pdp-2026')) {
      controllers.forEach(cleanup => cleanup());
      controllers.clear();
      scan(document);
    } else scan(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((cleanup, root) => {
      if (event.target.contains(root) || event.target.querySelector('.battle-pdp-2026')) { cleanup(); controllers.delete(root); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["graphics-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('graphics-carousel')) {
    class GraphicsCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-carousel-scroller]');
        this.previousButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.progress = this.querySelector('[data-carousel-progress]');

        if (!this.scroller || !this.progress) return;

        this.isDragging = false;
        this.startX = 0;
        this.startScrollLeft = 0;

        this.handleScroll = this.update.bind(this);
        this.handleResize = this.update.bind(this);
        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handlePointerDown = this.onPointerDown.bind(this);
        this.handlePointerMove = this.onPointerMove.bind(this);
        this.handlePointerUp = this.onPointerUp.bind(this);

        this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
        this.scroller.addEventListener('keydown', this.handleKeydown);
        this.scroller.addEventListener('pointerdown', this.handlePointerDown);
        this.scroller.addEventListener('pointermove', this.handlePointerMove);
        this.scroller.addEventListener('pointerup', this.handlePointerUp);
        this.scroller.addEventListener('pointercancel', this.handlePointerUp);
        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.scroller);

        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.handleScroll);
        this.scroller?.removeEventListener('keydown', this.handleKeydown);
        this.scroller?.removeEventListener('pointerdown', this.handlePointerDown);
        this.scroller?.removeEventListener('pointermove', this.handlePointerMove);
        this.scroller?.removeEventListener('pointerup', this.handlePointerUp);
        this.scroller?.removeEventListener('pointercancel', this.handlePointerUp);
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.resizeObserver?.disconnect();
      }

      getStep() {
        const slide = this.scroller.querySelector('.graphics-carousel__slide');

        if (!slide) {
          return this.scroller.clientWidth;
        }

        const styles = window.getComputedStyle(this.scroller);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

        return slide.getBoundingClientRect().width + gap;
      }

      move(direction) {
        this.scroller.scrollBy({
          left: direction * this.getStep(),
          behavior: 'smooth'
        });
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        this.isDragging = true;
        this.startX = event.clientX;
        this.startScrollLeft = this.scroller.scrollLeft;
        this.scroller.classList.add('is-dragging');
        this.scroller.setPointerCapture(event.pointerId);
      }

      onPointerMove(event) {
        if (!this.isDragging) return;

        this.scroller.scrollLeft =
          this.startScrollLeft - (event.clientX - this.startX);
      }

      onPointerUp(event) {
        if (!this.isDragging) return;

        this.isDragging = false;
        this.scroller.classList.remove('is-dragging');

        if (this.scroller.hasPointerCapture(event.pointerId)) {
          this.scroller.releasePointerCapture(event.pointerId);
        }
      }

      update() {
        const maximumScroll = Math.max(
          this.scroller.scrollWidth - this.scroller.clientWidth,
          0
        );

        const visibleRatio = Math.min(
          this.scroller.clientWidth / this.scroller.scrollWidth,
          1
        );

        const progress =
          maximumScroll === 0
            ? 0
            : this.scroller.scrollLeft / maximumScroll;

        this.progress.style.width = `${visibleRatio * 100}%`;
        this.progress.style.left =
          `${progress * (1 - visibleRatio) * 100}%`;

        if (this.previousButton) {
          this.previousButton.disabled = this.scroller.scrollLeft <= 2;
        }

        if (this.nextButton) {
          this.nextButton.disabled =
            this.scroller.scrollLeft >= maximumScroll - 2;
        }
      }
    }

    customElements.define('graphics-carousel', GraphicsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
